<template>
 <div class="title-report"><b>گزارش دستورات صادر شده</b></div>
  <div class="wells-wrapper" style="display: flex; flex-wrap: wrap; gap: 16px;">
   
    <div
      v-for="well in props.data"
      :key="well.id"
      class="mb-12"
      :id="'table-command-' + well.id"
      style="flex: 1 1 300px;" 
    >
      <el-card shadow="hover">
        <div class="font-bold text-lg mb-5" style="margin-bottom:10px">{{ well.name }}</div>

        <!-- جدول اصلی -->
        <el-table
          :data="well.dates"
          style="width: 100%"
          row-key="date"
          :default-expand-all="false"
          border
          :expand-row-keys="expandedRows"
          class="custom-expand"
        >
          <el-table-column prop="date" label="تاریخ" width="150" />
          <el-table-column label="آمار دستورات">
            <template #default="scope">
              {{ formatTypes(scope.row.typesCount) }}
            </template>
          </el-table-column>
          <!-- ستون تاریخ -->
          <el-table-column type="expand">
            <template #default="props">
              <el-table :data="props.row.hours" size="small" border>
                <el-table-column prop="time" label="ساعت" width="100" />
                <el-table-column prop="status" label="وضعیت" />
                <el-table-column prop="type" label="نوع دستور" />
              </el-table>
            </template>
          </el-table-column>
        </el-table>

        <!-- جمع کلی -->
        <div class="mt-4 text-sm text-gray-600">
          <br />
          جمع کلی دستورات: دستی: {{ well.totalTypesCount.manual }}, هوشمند:
          {{ well.totalTypesCount.smart }}, برنامه‌ریزی:
          {{ well.totalTypesCount.schedule }}, کاربر(سایت):
          {{ well.totalTypesCount.web }}
        </div>
        <div class="mt-8 flex gap-4 mb-5">
          <br />
          <el-button type="primary" @click="exportExcel(well.id)"> خروجی اکسل</el-button>
          <el-button
            @click="exportTableImage(well.id, well.dates)"
            style="margin-right: 10px"
          >
            خروجی عکس</el-button
          >
        </div>
      </el-card>
      <br>
    </div>

    <!-- دکمه‌های خروجی -->
  </div>
</template>

<script setup>
import { ref, computed, defineProps, nextTick } from "vue";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";

const props = defineProps({ data: { type: Array, default: () => [] } });
const expandedRows = ref(null);
function sanitizeSheetName(name) {
  return name.replace(/[:\\\/\?\*\[\]]/g, "_");
}

function exportExcel(wellId) {
  const wb = XLSX.utils.book_new();
const well = props.data.find((w) => w.id === wellId);
  if (!well) return;

 
    well.dates.forEach((dateItem) => {
      const ws = XLSX.utils.json_to_sheet(dateItem.hours);
      const sheetName = sanitizeSheetName(`${dateItem.date}`);
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
    });


  // فقط اکسل بسازه
  XLSX.writeFile(wb, `command_list_${well.name}.xlsx`, { bookType: "xlsx" });
}

function formatTypes(typesCount) {
  const parts = [];
  if (typesCount.manual > 0) parts.push(`دستی: ${typesCount.manual}`);
  if (typesCount.smart > 0) parts.push(`هوشمند: ${typesCount.smart}`);
  if (typesCount.schedule > 0)
    parts.push(`برنامه‌ریزی: ${typesCount.schedule}`);
  if (typesCount.web > 0) parts.push(`کاربر(سایت): ${typesCount.web}`);
  return parts.join(", ");
}
// خروجی عکس
async function exportTableImage(wellId, wellDates) {
  const tableEl = document.getElementById(`table-command-${wellId}`);
  if (!tableEl) return;
  expandedRows.value = wellDates.map((d) => d.date); // همه باز
  await nextTick(); // صبر کن تا render بشه

  await new Promise((r) => setTimeout(r, 50)); // 50ms تا جدول expand شده کاملا آپدیت شود

  html2canvas(tableEl).then((canvas) => {
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = "command_table.png";
    link.click();
  });
}
</script>
<style scoped>
/* جابجایی آیکن expand از راست به چپ */
::v-deep(.custom-expand .el-table__expand-icon) {
  float: left !important;
  margin-left: 10px;
  margin-right: 0;
}
/* وقتی بسته است → فلش به راست (الان سمت چپ جدولیم، پس باید برعکس شه) */
::v-deep(.custom-expand .el-table__expand-icon) {
  transform: rotate(180deg);
}

/* وقتی باز میشه → فلش به پایین */
::v-deep(
    .custom-expand .el-table__expand-icon.el-table__expand-icon--expanded
  ) {
  transform: rotate(90deg);
}
::v-deep(.el-table .cell) {
  text-align: center;
}
.title-report{
  text-align: right;
  padding: 10px;
}
</style>
